// import React, { useEffect, useRef } from "react";
// import { useLocation, useNavigate, useParams } from "react-router-dom";
// import { Helmet } from "react-helmet-async";
// import { ArrowLeft, ArrowRight } from "lucide-react";

// // Import videos and thumbnails (same as CollectionsPage)
// import vid1 from '../../Assesst/vide1.mp4';
// import vid2 from '../../Assesst/vid2.mp4';
// import vid3 from '../../Assesst/vid3.mp4';
// import vid4 from '../../Assesst/vid4.mp4';
// import vid5 from '../../Assesst/vid5.mp4';
// import vid6 from '../../Assesst/vid6.mp4';
// import vid8 from '../../Assesst/laminancekitchen.mp4';

// import thm1 from '../../Assesst/Image-73.jpg';
// import thm2 from '../../Assesst/Image-883.jpg';
// import thm3 from '../../Assesst/Image-121.jpg';
// import thm4 from '../../Assesst/Image-912.jpg';
// import thm5 from '../../Assesst/videoframe_0.png';
// import thm6 from '../../Assesst/629992239_17898564786381730_7476464499665088684_n.jpg';
// import thm7 from "../../Assesst/vid1.mp4";
// import thm9 from "../../Assesst/newkit.jpeg";

// const VideoPage = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { videoId } = useParams(); // Get videoId from URL
//   const videoRef = useRef(null);
  
//   // Complete collections data (fallback for direct URL access)
//   const collectionsData = {
//     collection1: { id: "collection1", video: vid8, thumbnail: thm9 },
//     collection2: { id: "collection2", video: vid1, thumbnail: thm1 },
//     collection3: { id: "collection3", video: vid2, thumbnail: thm2 },
//     collection4: { id: "collection4", video: vid3, thumbnail: thm3 },
//     collection5: { id: "collection5", video: vid4, thumbnail: thm4 },
//     collection6: { id: "collection6", video: vid5, thumbnail: thm5 },
//     collection7: { id: "collection7", video: vid6, thumbnail: thm6 },
//     collection8: { id: "collection8", video: vid1, thumbnail: thm7 },
//   };

//   // Get collection from state (if coming from CollectionsPage) or from URL param
//   const collection = location.state?.collection || collectionsData[videoId];

//   useEffect(() => {
//     // If no collection data found, redirect back to collections page
//     if (!collection && !collectionsData[videoId]) {
//       navigate("/collections", { replace: true });
//     }
//   }, [collection, videoId, navigate]);

//   const handleGoBack = () => {
//     navigate("/collections");
//   };

//   const handleBookConsultation = () => {
//     navigate("/contact#contact-form");
//   };

//   // Show loading state while checking data
//   if (!collection && !collectionsData[videoId]) {
//     return (
//       <div className="min-h-screen flex items-center justify-center">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500 mx-auto"></div>
//           <p className="mt-4 text-gray-600">Loading video...</p>
//         </div>
//       </div>
//     );
//   }

//   const activeCollection = collection || collectionsData[videoId];
//   const collectionNumber = activeCollection.id.replace("collection", "");

//   const videoSchema = {
//     "@context": "https://schema.org",
//     "@type": "VideoObject",
//     "name": `Laminance Cabinetry Kitchen Collection ${collectionNumber}`,
//     "description": `Premium kitchen cabinet collection showcase by Laminance Cabinetry. Modern kitchen design and custom cabinetry in New Jersey.`,
//     "thumbnailUrl": activeCollection.thumbnail,
//     "contentUrl": activeCollection.video,
//     "embedUrl": `https://laminance.com/collections/video/${activeCollection.id}`,
//     "uploadDate": "2025-01-01",
//     "duration": "PT2M",
//     "provider": {
//       "@type": "Organization",
//       "name": "Laminance Cabinetry",
//       "sameAs": "https://laminance.com"
//     }
//   };

//   return (
//     <>
//       <Helmet>
//         <title>Laminance Cabinetry Kitchen Collection {collectionNumber} | Custom Cabinet Video</title>
//         <meta name="description" content={`Watch our premium kitchen cabinet collection ${collectionNumber} showcase. Modern custom cabinets by Laminance Cabinetry in New Jersey. Free consultation available.`} />
//         <link rel="canonical" href={`https://laminance.com/collections/video/${activeCollection.id}`} />
        
//         {/* Open Graph */}
//         <meta property="og:type" content="video.other" />
//         <meta property="og:url" content={`https://laminance.com/collections/video/${activeCollection.id}`} />
//         <meta property="og:title" content={`Laminance Cabinetry Kitchen Collection ${collectionNumber}`} />
//         <meta property="og:description" content={`Watch our premium kitchen cabinet collection ${collectionNumber} showcase.`} />
//         <meta property="og:image" content={activeCollection.thumbnail} />
//         <meta property="og:video" content={activeCollection.video} />
//         <meta property="og:video:type" content="video/mp4" />
//         <meta property="og:video:width" content="1280" />
//         <meta property="og:video:height" content="720" />
        
//         {/* Twitter Card */}
//         <meta name="twitter:card" content="player" />
//         <meta name="twitter:title" content={`Laminance Cabinetry Kitchen Collection ${collectionNumber}`} />
//         <meta name="twitter:description" content={`Watch our premium kitchen cabinet collection ${collectionNumber} showcase.`} />
//         <meta name="twitter:image" content={activeCollection.thumbnail} />
//         <meta name="twitter:player" content={activeCollection.video} />
        
//         {/* Structured Data */}
//         <script type="application/ld+json">{JSON.stringify(videoSchema)}</script>
//       </Helmet>

//       <section className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
//         <div className="max-w-5xl mx-auto">
//           {/* Back Button */}
//           <button
//             onClick={handleGoBack}
//             className="inline-flex items-center gap-2 mb-6 px-4 py-2 rounded-lg bg-white shadow-md hover:shadow-lg transition-all duration-300 hover:bg-gray-50"
//             aria-label="Back to collections"
//           >
//             <ArrowLeft size={20} />
//             <span>Back to Collections</span>
//           </button>

//           {/* Video Container */}
//           <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
//             <div className="aspect-video bg-black">
//               <video
//                 ref={videoRef}
//                 key={activeCollection.video}
//                 className="w-full h-full"
//                 controls
//                 autoPlay
//                 playsInline
//                 poster={activeCollection.thumbnail}
//                 title={`Laminance Cabinetry Kitchen Collection ${collectionNumber}`}
//                 aria-label={`Video showcasing Laminance Cabinetry kitchen collection ${collectionNumber}`}
//               >
//                 <source src={activeCollection.video} type="video/mp4" />
//                 Your browser does not support the video tag. 
//                 Watch Laminance Cabinetry kitchen collection {collectionNumber} showcase.
//               </video>
//             </div>

//             {/* Video Details */}
//             <div className="p-6 md:p-8">
//               <h1 className="bell-mt-primary text-2xl md:text-3xl font-bold mb-4" style={{ color: "var(--color-primary-500)" }}>
//                 Laminance Cabinetry Kitchen Collection {collectionNumber}
//               </h1>
              
//               <p className="inter-secondary text-base md:text-lg mb-6 leading-relaxed" style={{ color: "var(--color-gray-600)" }}>
//                 Experience premium quality custom kitchen cabinets by Laminance Cabinetry. 
//                 This collection showcases our commitment to excellence, modern design, and superior craftsmanship.
//                 Perfect for homeowners looking for custom kitchen cabinets in New Jersey.
//               </p>

//               <div className="flex flex-col sm:flex-row gap-4">
//                 <button
//                   onClick={handleBookConsultation}
//                   className="inline-flex items-center justify-center gap-2 px-8 py-3 rounded-xl font-bold text-white transition-all duration-300 hover:scale-105"
//                   style={{ background: "var(--gradient-primary)" }}
//                   aria-label="Get free design consultation for this kitchen collection"
//                 >
//                   Get Free Design Consultation
//                   <ArrowRight size={18} />
//                 </button>
                
//                 <button
//                   onClick={() => window.open('/catalog', '_blank')}
//                   className="inline-flex items-center justify-center gap-2 px-8 py-3 rounded-xl font-bold text-gray-700 bg-white border-2 border-gray-200 transition-all duration-300 hover:border-primary-500 hover:text-primary-500"
//                 >
//                   View All Collections
//                 </button>
//               </div>
//             </div>
//           </div>

//           {/* Related Collections Section */}
//           <div className="mt-12">
//             <h2 className="bell-mt-primary text-xl md:text-2xl font-bold text-center mb-6" style={{ color: "var(--color-primary-500)" }}>
//               Explore More Collections
//             </h2>
//             <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
//               {Object.values(collectionsData).slice(0, 4).map((item) => (
//                 <div
//                   key={item.id}
//                   onClick={() => navigate(`/collections/video/${item.id}`, { state: { collection: item } })}
//                   className="cursor-pointer group rounded-xl overflow-hidden bg-white shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
//                 >
//                   <div className="aspect-video">
//                     <img
//                       src={item.thumbnail}
//                       alt={`Collection ${item.id.replace("collection", "")}`}
//                       className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
//                     />
//                   </div>
//                   <div className="p-2 text-center">
//                     <p className="text-xs font-semibold" style={{ color: "var(--color-primary-500)" }}>
//                       Collection {item.id.replace("collection", "")}
//                     </p>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Share URL */}
//           <div className="mt-8 text-center">
//             <p className="inter-secondary text-sm" style={{ color: "var(--color-gray-500)" }}>
//               <strong>Share this collection:</strong> 
//             </p>
//             <code className="inter-secondary text-xs mt-2 inline-block px-4 py-2 bg-gray-100 rounded-lg break-all">
//               https://laminance.com/collections/video/{activeCollection.id}
//             </code>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default VideoPage;



import React, { useRef, useEffect } from 'react';
import { X } from 'lucide-react';

const VideoModal = ({ video, onClose }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch(e => console.log("Autoplay prevented:", e));
    }
    document.body.style.overflow = 'hidden';
    
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [video]);

  const handleClose = () => {
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
    onClose();
  };

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        handleClose();
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, []);

  return (
    <div 
      className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center backdrop-blur-sm"
      onClick={handleClose}
      role="dialog"
      aria-modal="true"
      aria-label="Video player modal"
    >
      <button
        onClick={handleClose}
        className="absolute top-4 right-4 z-50 bg-black/50 hover:bg-black text-white p-3 rounded-full transition-all duration-200"
        aria-label="Close video"
      >
        <X size={28} />
      </button>

      <div 
        className="relative w-full max-w-6xl mx-4 rounded-2xl overflow-hidden shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="absolute top-0 left-0 right-0 bg-gradient-to-b from-black/70 to-transparent p-4 z-10">
          <h3 className="text-white text-lg font-semibold">{video.title || "Laminance Cabinetry Kitchen Collection"}</h3>
        </div>

        <video
          ref={videoRef}
          src={video.video}
          className="w-full h-auto max-h-[85vh] object-contain"
          controls
          autoPlay
          playsInline
          poster={video.thumbnail}
          aria-label={`Video showcasing ${video.title || "Laminance Cabinetry kitchen collection"}`}
          title={video.title}
        >
          <source src={video.video} type="video/mp4" />
          Your browser does not support the video tag. Watch Laminance Cabinetry premium kitchen collection video.
        </video>
      </div>

      <div className="absolute bottom-6 left-0 right-0 text-center">
        <p className="text-white/50 text-sm inter-secondary">
          Press ESC to close • Click outside to close
        </p>
      </div>
    </div>
  );
};

export default VideoModal;